import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  font-weight: 600;
`;

const TitleContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
`;

const Title = styled.div`
  font-size: 32px;
  margin-bottom: 30px;
  font-weight: 800;
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const SubTitle = styled.div`
  line-height: 1.5;
  opacity: 0.6;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Ul = styled.ul`
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
`;
const Li = styled.li`
  margin: 15px;
  color: ${props => (props.current ? 'red' : 'white')};
  opacity: ${props => (props.current ? '1' : '0.8')};
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.1);
    opacity: 1;
  }
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const PageHeader = ({ location: { pathname } }) => {
  return (
    <Container>
      {pathname && pathname === '/movie' && (
        <TitleContainer>
          <Title>인기 영화</Title>
          <SubTitle>현재 인기 있는 영화 목록을 가져옵니다.</SubTitle>
          <SubTitle>영화 목록은 매일 자동 업데이트됩니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname && pathname === '/movie/now-playing' && (
        <TitleContainer>
          <Title>현재 상영중인 영화</Title>
          <SubTitle>현재 상영중인 영화 목록을 가져옵니다.</SubTitle>
          <SubTitle>지정된 날짜 내에서 상영중인 모든 영화를 찾습니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname && pathname === '/movie/top-rated' && (
        <TitleContainer>
          <Title>평점높은 영화</Title>
          <SubTitle>
            모든 영화 중에서 평점이 높은 영화 목록을 가져옵니다.
          </SubTitle>
          <SubTitle>평점이 높은 영화를 기준으로 정렬합니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname && pathname === '/tv' && (
        <TitleContainer>
          <Title>인기 프로그램</Title>
          <SubTitle>현재 인기 있는 TV 프로그램 목록을 가져옵니다.</SubTitle>
          <SubTitle>TV 프로그램 목록은 매일 자동 업데이트됩니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname && pathname === '/tv/airing-today' && (
        <TitleContainer>
          <Title>현재 방영중인 프로그램</Title>
          <SubTitle>현재 방영중인 TV 프로그램 목록을 가져옵니다.</SubTitle>
          <SubTitle>오늘 날짜를 기준으로 목록을 가져옵니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname && pathname === '/tv/top-rated' && (
        <TitleContainer>
          <Title>평점높은 TV 프로그램</Title>
          <SubTitle>
            모든 TV 프로그램 중에서 평점이 높은 프로그램을 가져옵니다.
          </SubTitle>
          <SubTitle>평점이 높은 프로그램을 기준으로 정렬합니다.</SubTitle>
        </TitleContainer>
      )}
      {pathname.includes('/movie') ? (
        <Ul>
          <Li current={pathname === '/movie'}>
            <Link to="/movie">인기 영화</Link>
          </Li>
          <Li current={pathname === '/movie/now-playing'}>
            <Link to="/movie/now-playing">현재 상영중인 영화</Link>
          </Li>
          <Li current={pathname === '/movie/top-rated'}>
            <Link to="/movie/top-rated">평점 높은 영화</Link>
          </Li>
        </Ul>
      ) : (
        <Ul>
          <Li current={pathname === '/tv'}>
            <Link to="/tv">인기 프로그램</Link>
          </Li>
          <Li current={pathname === '/tv/airing-today'}>
            <Link to="/tv/airing-today">현재 방영중</Link>
          </Li>
          <Li current={pathname === '/tv/top-rated'}>
            <Link to="/tv/top-rated">평점 높은 프로그램</Link>
          </Li>
        </Ul>
      )}
    </Container>
  );
};

export default withRouter(PageHeader);
